import React, { memo, useEffect, useState } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { useLegendConfigWithYearMonth } from './context';
import { BMPrimitives, useBMTheme } from '../../theme';
import LegendBadge from './LegendBadge';
/**
 * HolidayBar component, consisted of HolidayBadge components.
 *
 * [13 Cuti Bersama]
 */
function LegendBar(props) {
    const { activeTheme, BMComponents } = useBMTheme();
    const [styles, setStyles] = useState(() => legendBarStyles(BMComponents));
    const { horizontal, year, month } = props;
    const legendConfig = useLegendConfigWithYearMonth(year, month + 1);
    const legendLength = Object.keys(legendConfig).length;
    useEffect(() => {
        setStyles(() => legendBarStyles(BMComponents));
    }, [activeTheme]);
    if (legendLength > 0) {
        const Container = horizontal
            ? {
                Element: View,
                props: {
                    style: [styles.container, styles.wrapContainer],
                },
            }
            : {
                Element: ScrollView,
                props: {
                    horizontal: true,
                    showsHorizontalScrollIndicator: false,
                    style: styles.container,
                },
            };
        return (<View>
        <Container.Element {...Container.props}>
          {legendConfig.map(({ legendType, definition }, index) => {
                const isLastLegend = index === legendLength - 1;
                const badgeContainerStyle = !isLastLegend
                    ? {
                        marginRight: BMPrimitives.BMSize.md,
                    }
                    : {};
                return (<View key={`${index}-${definition}`} style={badgeContainerStyle}>
                <LegendBadge legendType={legendType} definition={definition}/>
              </View>);
            })}
        </Container.Element>
      </View>);
    }
    return null;
}
const legendBarStyles = (BMComponents) => StyleSheet.create({
    container: {
        padding: BMPrimitives.BMSize.md,
        backgroundColor: BMComponents.BMUiCalendarBgcolorPrimary,
    },
    wrapContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        rowGap: BMPrimitives.BMSize.md,
    },
});
export default memo(LegendBar);
